import { capitalizeFirstLetter } from "./StringHelpers";
export function formatFormula(formula) {
    return formula
        .replace("*", " x ")
        .replace("+", " + ")
        .replace("-", " - ")
        .replace("/", " ÷ ");
}

export function capitalizeUnitName(unit, name) {
    if (!unit) return ''
    if (!unit[name]) return capitalizeFirstLetter(unit.common_name)
    return unit[name] === unit.abbreviation ? capitalizeFirstLetter(unit.abbreviation) : capitalizeFirstLetter(unit[name])
}